import { getLocales } from 'expo-localization'

const getDeviceLanguageCode = () => {
  let { languageCode } = getLocales()[0]
  return languageCode
}

const isJa = () => {
  return getDeviceLanguageCode() == 'ja'
}

const isJaOrZh = () => {
  return ['ja', 'zh'].includes(getDeviceLanguageCode())
}

export { getDeviceLanguageCode, isJa, isJaOrZh }

//========== EXTENSION ==========
declare global {
  interface String {
    orInJa(messageInOtherLanguage: string): string
  }
}

String.prototype.orInJa = function (messageInOtherLanguage: string) {
  if (isJaOrZh()) {
    return `${messageInOtherLanguage}`
  }
  return `${this}`
}
